import Icon from '../components/Icon.vue'

Icon.register({"star-half":{"width":576,"height":512,"paths":[{"d":"M288 0C276.6 0 265.2 5.9 259.3 17.8L194 150.2 47.9 171.4C21.7 175.2 11.2 207.5 30.2 226L135.9 329 110.9 474.5C106.4 500.6 133.9 520.5 157.3 508.2L288 439.6V0z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/star-half.js
// module id = EDW6
// module chunks = 0